import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
// import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// import { appConfig } from 'src/app/app.config';
import { HomeService } from 'src/app/services/home/home.service';

@Injectable()
export class WatchDailyResolver {
  constructor(
    private _Title: Title,
    private _HomeService: HomeService,
    private _Meta: Meta,
  ) {}

  resolve(): any {
    return true;
  }
}
